export const getClassificationName = (classificationId, classifications) => {
  const found = classifications.find(
    (classification) => classification.id == classificationId
  );
  return found ? found.label : null;
};
